/* eslint-disable camelcase */
import {
  AcademyTypes,
  AcademyLive,
  AcademySubscriptionPayload,
  AcademyFloatingState,
} from './types';

export const getAgenda = () => ({
  types: [
    AcademyTypes.GET_AGENDA_REQUEST,
    AcademyTypes.GET_AGENDA_SUCCESS,
    AcademyTypes.GET_AGENDA_FAILURE,
  ],
  promise: (client: any) => client.get('/academy/lives'),
});

export const getLiveNow = () => ({
  types: [
    AcademyTypes.GET_LIVE_NOW_REQUEST,
    AcademyTypes.GET_LIVE_NOW_SUCCESS,
    AcademyTypes.GET_LIVE_NOW_FAILURE,
  ],
  promise: (client: any) => client.get('/academy/lives/live_now'),
});

export const getContents = () => ({
  types: [
    AcademyTypes.GET_CONTENTS_REQUEST,
    AcademyTypes.GET_CONTENTS_SUCCESS,
    AcademyTypes.GET_CONTENTS_FAILURE,
  ],
  promise: (client: any) => client.get('/academy/lives/contents'),
});

export const getMySubscriptions = () => ({
  types: [
    AcademyTypes.GET_MY_SUBSCRIPTIONS_REQUEST,
    AcademyTypes.GET_MY_SUBSCRIPTIONS_SUCCESS,
    AcademyTypes.GET_MY_SUBSCRIPTIONS_FAILURE,
  ],
  promise: (client: any) => client.get('/academy/subscriptions'),
});

export const subscribe = (payload: AcademySubscriptionPayload) => ({
  types: [
    AcademyTypes.SUBSCRIBE_REQUEST,
    AcademyTypes.SUBSCRIBE_SUCCESS,
    AcademyTypes.SUBSCRIBE_FAILURE,
  ],
  promise: (client: any) => client.post('/academy/subscriptions', { subscription: payload }),
});

export const unsubscribe = (id: number) => ({
  types: [
    AcademyTypes.UNSUBSCRIBE_REQUEST,
    AcademyTypes.UNSUBSCRIBE_SUCCESS,
    AcademyTypes.UNSUBSCRIBE_FAILURE,
  ],
  id,
  promise: (client: any) => client.delete(`/academy/subscriptions/${id}`),
});

export const setLiveNow = (live: AcademyLive | null) => ({
  type: AcademyTypes.SET_LIVE_NOW,
  payload: live,
});

export const setFloatingState = (value: AcademyFloatingState) => ({
  type: AcademyTypes.SET_FLOATING_STATE,
  payload: value,
});
